import { EVENT_TYPES } from "nemuru-components";
import { modules } from "../../components/modules";
import { FLOW_MESSAGES } from "../../components/shared/components/flowMessages/components";
import { ONBOARDING_PARTICIPANT_ROLES } from "../../components/shared/config";
import { MILESTONES } from "../../components/shared/sharedKernel/EventCatcher/config";
import { findParticipantOnboardingDetailsByRole } from "../../utils/participants";
import { SECTIONS } from "../config";
import { BankReaderName } from "../../components/modules/income/BankReader/components/BankReaderFactory/types/BankReaderName";
import { ENV_DEFAULT_BANK_READER } from "../envVars";

export const flowTest = {
  name: "Test flow",
  modules: [
    {
      id: modules.SLIDER.id,
      onKO: null,
      section: {
        name: null,
      },
      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) =>
          !processState.participant.participantId,
        welcomeMessageId: FLOW_MESSAGES.APP_START.id,
      },
    },
    {
      id: modules.TERMS.id,
      onKO: null,
      section: {
        name: null,
      },
      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) =>
          !processState.loan?.borrower_user_details_on_origination,
        welcomeMessageId: FLOW_MESSAGES.WELCOME_BACK.id,
      },
    },
    {
      id: modules.KYC_MANUAL.id,
      section: {
        name: SECTIONS.IDENTIFICATION,
        progressPercentage: "50%",
      },
      onKO: null,
      onOK: {
        showOKMessage: {
          id: FLOW_MESSAGES.SECTION_IDENTIFICATION_END.id,
          fadeIn: true,
        },
        sendEvents: [
          {
            name: MILESTONES.KYC_COMPLETED,
            type: EVENT_TYPES.milestoneCompleted,
          },
        ],
      },
      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) =>
          !processState.loan?.borrower_user_details_on_origination,
        welcomeMessageId: FLOW_MESSAGES.WELCOME_BACK_WITH_PROGRESS.id,
      },
    },
    {
      id: modules.DECLARED_INCOME.id,
      onKO: null,
      section: {
        name: SECTIONS.FINANCES,
        progressPercentage: "50%",
      },
      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) =>
          processState.loan?.borrower_user_details_on_origination
            ?.familiar_situation_details &&
          !processState.loan?.borrower_bank_reader_id &&
          !processState.loan?.declared_income_id,
        welcomeMessageId: FLOW_MESSAGES.WELCOME_BACK_WITH_PROGRESS.id,
      },
    },
    {
      id: modules.CASH_IN_CASH_OUT_METHOD.id,
      onKO: null,
      section: {
        name: SECTIONS.FINANCES,
        progressPercentage: "75%",
      },
      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) =>
          ENV_DEFAULT_BANK_READER === BankReaderName.TINK &&
          !processState.loan?.borrower_cash_in_cash_out_method_id &&
          findParticipantOnboardingDetailsByRole(
            processState.loan,
            ONBOARDING_PARTICIPANT_ROLES.BORROWER
          )?.borrower_bank_reader_id &&
          processState.participant.role ===
            ONBOARDING_PARTICIPANT_ROLES.BORROWER,
        welcomeMessageId: FLOW_MESSAGES.WELCOME_BACK_WITH_PROGRESS.id,
      },
    },
    {
      id: modules.PROFESSIONAL_DATA.id,
      section: {
        name: SECTIONS.FINANCES,
        progressPercentage: "100%",
      },
      onKO: null,
      onOK: {
        sendEvents: [
          {
            name: MILESTONES.PROFESSIONAL_DETAILS_COMPLETED,
            type: EVENT_TYPES.milestoneCompleted,
          },
        ],
      },
      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) =>
          !processState.loan?.borrower_user_details_on_origination
            ?.professional_details,
        welcomeMessageId: FLOW_MESSAGES.WELCOME_BACK_WITH_PROGRESS.id,
      },
    },
    {
      id: modules.SUMMARY_AND_ADJUST.id,
      section: {
        name: SECTIONS.SUMMARY,
        progressPercentage: "33%",
      },
      onOK: {
        sendEvents: [
          {
            name: MILESTONES.APPLICATION_CREATED_IN_LENDER,
            type: EVENT_TYPES.milestoneCompleted,
          },
        ],
      },
      onKO: null,
      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) =>
          processState.loan?.loan_application_ids?.length === 0 ||
          !processState.loan?.loan_application_ids,
        welcomeMessageId: FLOW_MESSAGES.WELCOME_BACK_WITH_PROGRESS.id,
      },
    },
    {
      id: modules.APPLICATION_INFO.id,
      onKO: null,
      section: {
        name: SECTIONS.SUMMARY,
        progressPercentage: "66%",
      },
      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) =>
          processState.loan?.loan_application_ids &&
          processState.loan?.loan_application_ids?.length > 0,
        welcomeMessageId: FLOW_MESSAGES.WELCOME_BACK.id,
      },
    },
    {
      id: modules.DOCUMENTATION.id,
      onKO: null,
      section: {
        name: SECTIONS.SUMMARY,
        progressPercentage: "80%",
      },
    },
    {
      id: modules.OPTINS_AND_SIGNATURE.id,
      onKO: null,
      section: {
        name: SECTIONS.SUMMARY,
        progressPercentage: "100%",
      },
    },
    {
      id: modules.APPLICATION_INFO.id,
      onKO: null,
      section: {
        name: null,
      },
    },
  ],
};
